<template>
    <div>
          <template v-if="room && !roomLoading">
            <v-snackbar :color="snackbarColor" v-model="snackbarValue" top>
                {{ snackbarText }}
                <template v-slot:action>
                    <v-icon @click="hideSnackbar">mdi-close</v-icon>
                </template>
            </v-snackbar>
            <chat :id="room.chat.id" v-if="room.chat.active"/>
            <v-container fluid :style="`background: #f2f4f5`"
                         :class="$vuetify.breakpoint.smAndDown ?'pa-0' : 'py-0'">
                <v-row justify="center" no-gutters>
                    <v-col cols="12" md="10" lg="8" xl="6" class="pa-0">
                      <template v-if="room.type==='zoom'">
                        <template v-if="room.preview_image">
                          <a :href="room.stream_url" target="_blank" v-if="room.live">
                            <v-img v-if="room.preview_image" :src="room.preview_image" :aspect-ratio="16/9" width="100%" contain>
                              <v-overlay absolute>
                                <v-btn color="primary" x-large :class="dark ? 'white--text' : 'black--text'">{{ $t('room.meeting.start') }}</v-btn>
                              </v-overlay>
                            </v-img>
                          </a>
                          <v-img v-else :src="room.preview_image" :aspect-ratio="16/9" width="100%" contain></v-img>
                        </template>
                      </template>
                        <video-player v-else :src="room.stream_url" :live="room.live"
                                      :poster="room.preview_image"/>
                    </v-col>
                </v-row>
            </v-container>
            <v-container fluid>
                <v-row justify="center" v-if="!room.live">
                    <v-col cols="12" md="10" lg="8" xl="6">
                        <v-card outlined>
                            <v-list class="py-0">
                                <v-list-item>
                                    <v-list-item-avatar>
                                        <v-icon>mdi-cast-off</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{ notLiveText }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle v-if="dateRange">
                                            {{ $t('room.not_live.scheduled_for', {date_range: dateRange}) }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                  <v-list-item-action v-if="room.start && room.end">
                                    <v-btn @click="downloadIcsFile" text><v-icon left>mdi-plus</v-icon>{{ $t('room.not_live.download') }}</v-btn>
                                  </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row justify="center" v-if="room.html_code">
                    <v-col cols="12" md="10" lg="8" xl="6">
                        <v-card elevation="0">
                            <v-card-text class="pa-0" v-html="room.html_code">
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="10" lg="8" xl="6">
                        <poll-dialog v-if="$vuetify.breakpoint.smAndDown"/>
                        <v-card elevation="0">
                            <v-tabs
                                    v-model="tab"
                                    show-arrows
                            >
                                <v-tab
                                        v-if="room.topics.length>0 || room.description">{{ room.description_heading ? room.description_heading :
                                    $t('room.description') }}
                                </v-tab>
                                <v-btn v-if="$vuetify.breakpoint.xs && room.certifiable && (room.live || (room.end && moment().isAfter(moment.tz(room.end, 'Europe/Berlin'))) )"
                                       text
                                       :loading="downloadingCertificate"
                                       :disabled="certificateDownloadCountdown>0"
                                       @click="downloadCertificate"
                                       color="primary"
                                       height="100%">
                                    <v-icon left>mdi-download</v-icon>{{ room.certificate_heading ? room.certificate_heading :
                                    $t('room.certificate') }} {{ certificateDownloadCountdown>0 ? displayableCertificateDownloadCountdown : '' }}
                                </v-btn>
                                <v-tab v-if="room.speakers && room.speakers.length>0">{{ room.speakers_heading ? room.speakers_heading :
                                    $t('room.speakers') }}
                                </v-tab>
                                <v-tab v-if="room.disclosure">{{ room.disclosure_heading ? room.disclosure_heading :
                                    $t('room.disclosure') }}
                                </v-tab>
                                <v-tab v-if="room.downloads.length>0">{{ room.downloads_heading ? room.downloads_heading :
                                    $t('room.downloads') }}
                                </v-tab>
                                <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
                                <v-btn v-if="$vuetify.breakpoint.smAndUp && room.certifiable && (room.live || (room.end && moment().isAfter(moment.tz(room.end, 'Europe/Berlin'))) )"
                                       text
                                       :loading="downloadingCertificate"
                                       :disabled="certificateDownloadCountdown>0"
                                       @click="downloadCertificate" color="primary"
                                       height="100%">
                                    <v-icon left>mdi-download</v-icon>{{ room.certificate_heading ? room.certificate_heading :
                                    $t('room.certificate') }} {{ certificateDownloadCountdown>0 ? displayableCertificateDownloadCountdown : '' }}
                                </v-btn>
                                <v-tab-item
                                        v-if="room.topics.length>0 || room.description"
                                >
                                    <v-card-text v-html="room.description">
                                    </v-card-text>
                                    <v-card-text v-if="room.topics.length>0">
                                        <v-list subheader dense>
                                            <v-list-item-subtitle
                                            >{{ room.topics_heading ? room.topics_heading :
                                                $t('room.topics') }}
                                            </v-list-item-subtitle>
                                                <template v-for="(topic, idx) in room.topics">
                                                    <v-list-item :key="idx">
                                                        <v-list-item-content>
                                                            <v-list-item-title
                                                                    class="font-weight-regular">{{
                                                                topic.name }}
                                                            </v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                    <v-divider v-if="idx<room.topics.length-1"
                                                               :key="`d+${idx}`"></v-divider>
                                                </template>
                                        </v-list>
                                    </v-card-text>
                                </v-tab-item>
                                <v-tab-item v-if="room.speakers.length>0">
                                    <v-card-text>
                                        <v-list subheader>
                                                <template v-for="(speaker, idx) in room.speakers">
                                                    <v-list-item :key="idx">
                                                        <v-list-item-content>
                                                            <v-list-item-title>{{ speaker.name }}
                                                            </v-list-item-title>
                                                            <v-list-item-subtitle
                                                                    v-for="(conflict, idx) in speaker.conflicts"
                                                                    :key="idx">
                                                                <span class="font-weight-bold">{{conflict.conflictType.name}}:</span>
                                                                {{conflict.conflicts }}
                                                            </v-list-item-subtitle>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                    <v-divider v-if="idx<room.speakers.length-1"
                                                               :key="`d+${idx}`"></v-divider>
                                                </template>
                                        </v-list>
                                    </v-card-text>
                                </v-tab-item>
                                <v-tab-item
                                        v-if="room.disclosure"
                                >
                                    <v-card-text>
                                        {{ room.disclosure }}
                                    </v-card-text>
                                </v-tab-item>
                                <v-tab-item
                                        v-if="room.downloads.length>0"
                                >
                                    <v-card-text>
                                        <v-list subheader>
                                            <template v-for="(download, idx) in room.downloads">
                                                <v-list-item :href="download.file" :key="idx" target="_blank">
                                                    <v-list-item-action>
                                                        <v-icon>{{fileIcon(download.file)}}</v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{ download.name }}</v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                                <v-divider v-if="idx<room.downloads.length-1"
                                                           :key="`d+${idx}`"></v-divider>
                                            </template>
                                        </v-list>
                                    </v-card-text>
                                </v-tab-item>
                            </v-tabs>
                            <template v-if="room.sponsors.length>0">
                                <v-divider/>
                                <div class="text-subtitle-1 mt-6">{{ room.sponsor_heading ? room.sponsor_heading :
                                    $t('room.sponsor_heading') }}
                                </div>
                                <v-row align="stretch">
                                    <v-col v-for="(sponsor, idx) in room.sponsors" :key="idx" cols="12" sm="6" md="4"
                                           lg="3"
                                           xl="2">
                                        <sponsor :sponsor="sponsor" :show-name="room.sponsors_show_name"></sponsor>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
          </template>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import Chat from '@/components/Chat';
    import VideoPlayer from '@/components/Player';
    import gql from 'graphql-tag';
    import PollDialog from '@/components/PollDialog';
    import snackbar from '@/mixins/snackbar';
    import Sponsor from '@/components/Sponsor';
    import { errorKind } from '@/errors';


    export default {
        name: 'Room',
        // eslint-disable-next-line vue/no-unused-components
        components: { Sponsor, PollDialog, VideoPlayer, Chat },
        props: {
            id: [String, Number],
        },
        mixins: [snackbar],
        data: () => ( {
            tab: 0,
            downloadingCertificate: false,
            certificateDownloadReadyDateTime: null,
            certificateDownloadCountdown: null,
            updateCertificateCountdownInterval: null,
            viewId: null,
            viewRoomId: null,
            viewHeartbeatInterval: null,
        } ),
        mounted ()
        {
            this.setRoomLoading(true)
            this.init(this.id);
            window.addEventListener( 'pagehide', this.onPageHide );
        },
        beforeRouteUpdate(to, from, next) {
          this.setRoomLoading(true)
          this.leaveRoom();
          this.$echo.leave( `App.Frontend.WaitingRoom.${ this.room.id }` );
          this.init(to.params.id)
          next()
        },
        beforeDestroy ()
        {
            window.removeEventListener( 'pagehide', this.onPageHide );
            if(this.room) {
                this.leaveRoom();
                this.$echo.leave( `App.Frontend.WaitingRoom.${ this.room.id }` );
            }
        },
        methods: {
            ...mapActions( ['updateRoom'] ),
            ...mapMutations (['setRoomLoading']),
            updateCertificateCountdown(){
              if(this.certificateDownloadReadyDateTime) {
                this.certificateDownloadCountdown = this.certificateDownloadReadyDateTime.diff(this.moment())
                if(this.certificateDownloadCountdown<=0) {
                  clearInterval(this.updateCertificateCountdownInterval)
                }
              }
            },
            fileIcon ( url )
            {
                let extension = url.split( '.' ).pop();
                return extension === 'pdf' ? 'mdi-file-pdf-outline' : 'mdi-file-image-outline';
            },
            downloadCertificate ()
            {
                let room_id = this.room.id;
                this.downloadingCertificate = true;
                this.$apollo.mutate( {
                    // Query
                    mutation: gql`mutation ($room_id: ID!) {
                                downloadCertificate(room_id: $room_id)
                              }`,
                    variables: {
                        room_id: room_id,
                    },
                } ).then( ( { data } ) =>
                {
                    this.downloadingCertificate = false;
                    var a = document.createElement( 'a' );
                    a.href = 'data:application/pdf;base64,' + data.downloadCertificate;
                    a.download = 'Zertifikat.pdf';
                    a.click();
                } ).catch( ( error ) =>
                {
                    let { graphQLErrors } = error;
                    if ( graphQLErrors && graphQLErrors.length > 0 && errorKind( graphQLErrors[ 0 ] ) === 'generic' )
                    {
                        this.showErrorSnackbar( graphQLErrors[ 0 ].message );
                    }
                    else
                    {
                        this.showGeneralErrorSnackbar();
                    }
                } ).finally(()=>{
                  this.downloadingCertificate = false;
                });
            },
          downloadIcsFile() {
              if(this.room.start && this.room.end) {
                let fileContent =
                    "BEGIN:VCALENDAR\n" +
                    "PRODID:streamedupevents\n" +
                    "VERSION:2.0\n" +
                    "BEGIN:VEVENT\n" +
                    "UID:streamedupevents"+this.room.id+"\n" +
                    "DTSTART:" +
                    this.moment.tz( this.room.start, 'Europe/Berlin' ).utc().format('YYYYMMDDTHHmmss') + 'Z' +
                    "\n" +
                    "DTEND:" +
                    this.moment.tz( this.room.end, 'Europe/Berlin' ).utc().format('YYYYMMDDTHHmmss') + 'Z' +
                    "\n" +
                    "SUMMARY:" +
                    this.frame.title + ' - ' + this.room.title +
                    "\n" +
                    "URL;VALUE=URI:" +
                    window.location +
                    "\n" +
                    "DESCRIPTION:" +
                    window.location +
                    "\n" +
                    "END:VEVENT\n" +
                    "END:VCALENDAR";
                let a = document.createElement( 'a' );
                a.href = "data:text/calendar;charset=utf8," + escape(fileContent);
                a.download = `${this.frame.title} - ${this.room.title}.ics`;
                a.click();
                a.remove();
              }
          },
            init (id)
            {
                this.$apollo.query( {
                    query: gql`
                    query roomsEdit($id: ID!){
                        roomsEdit(id: $id) {
                                id
                                type
                                title
                                start
                                end
                                preview_image
                                description
                                html_code
                                description_heading
                                certificate_heading
                                remaining_certificate_visitor_threshold
                                disclosure_heading
                                sponsor_heading
                                downloads_heading
                                topics_heading
                                speakers_heading
                                sponsors_show_name
                                disclosure
                                certifiable
                                speakers {
                                    name
                                    conflicts {
                                        conflictType {
                                            name
                                        }
                                        conflicts
                                    }
                                }
                                topics {
                                    name
                                }
                                downloads {
                                    name
                                    file
                                }
                                sponsors {
                                    advanced
                                    name
                                    file
                                    link
                                    description
                                    downloads_heading
                                    contacts_heading
                                    downloads {
                                        name
                                        file
                                    }
                                    contacts {
                                        heading
                                        text
                                    }
                                }
                                live
                                stream_url
                                chat {
                                    id
                                    active
                                }
                                pollSetting {
                                    id
                                    active_poll {
                                        id
                                        question
                                        answers {
                                            id
                                            answer
                                        }
                                    }
                                }
                            }
                }`,
                    variables: {
                        id: id,
                    },
                  fetchPolicy: "network-only"
                } ).then( ( { data } ) =>
                {
                    if ( data )
                    {
                        this.updateRoom( data.roomsEdit );
                        this.joinWaitingRoom();
                        if(this.room.remaining_certificate_visitor_threshold) {
                          this.certificateDownloadReadyDateTime = this.moment().add(this.room.remaining_certificate_visitor_threshold, 's');
                        }
                        if ( this.room.live )
                        {
                            this.joinRoom();
                        }
                    }
                } ).finally(()=>{
                  this.setRoomLoading(false)
                });
            },
            joinRoom ()
            {
                clearInterval( this.updateCertificateCountdownInterval )
                this.updateCertificateCountdownInterval = setInterval( this.updateCertificateCountdown, 100 )
                this.$echo.private( `App.Frontend.Room.${ this.id }` ).listen( 'FrontendPollSettingUpdated', ( pollSetting ) =>
                {
                  if ( pollSetting )
                  {
                    this.room.pollSetting = Object.assign( {}, pollSetting );
                  }
                } )
                this.startView();
            },
            leaveRoom ()
            {
                this.$echo.leave( `App.Frontend.Room.${ this.room.id }` );
                clearInterval( this.updateCertificateCountdownInterval );
                clearInterval( this.viewHeartbeatInterval );
                if ( this.viewId )
                {
                    this.sendHeartbeat( this.viewId ).catch( () => {} );
                }
                this.viewId = null;
                this.viewRoomId = null;
            },
            startView ()
            {
                let roomId = this.room.id;
                this.viewRoomId = roomId;
                this.$apollo.mutate( {
                    mutation: gql`mutation ($room_id: ID!) {
                                startView(room_id: $room_id)
                              }`,
                    variables: {
                        room_id: String( roomId ),
                    },
                } ).then( ( { data } ) =>
                {
                    // Null for admins and moderators; ignore results that arrive after the visitor left
                    if ( data.startView && this.viewRoomId === roomId )
                    {
                        clearInterval( this.viewHeartbeatInterval );
                        this.viewId = data.startView;
                        this.viewHeartbeatInterval = setInterval( this.heartbeatView, 30000 );
                    }
                } ).catch( () => {} );
            },
            heartbeatView ()
            {
                let viewId = this.viewId;
                this.sendHeartbeat( viewId ).then( ( { data } ) =>
                {
                    // After a gap of more than 90 seconds the backend starts a new view with a new id
                    if ( this.viewId === viewId )
                    {
                        this.viewId = data.heartbeatView;
                    }
                } ).catch( () =>
                {
                    if ( this.viewId === viewId )
                    {
                        clearInterval( this.viewHeartbeatInterval );
                        this.viewId = null;
                    }
                } );
            },
            sendHeartbeat ( viewId )
            {
                return this.$apollo.mutate( {
                    mutation: gql`mutation ($id: ID!) {
                                heartbeatView(id: $id)
                              }`,
                    variables: {
                        id: viewId,
                    },
                } );
            },
            onPageHide ()
            {
                // Apollo requests are cancelled when the tab closes; keepalive lets this one finish
                if ( this.viewId )
                {
                    fetch( process.env.VUE_APP_GRAPHQL_HTTP, {
                        method: 'POST',
                        keepalive: true,
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify( {
                            query: 'mutation ($id: ID!) { heartbeatView(id: $id) }',
                            variables: { id: this.viewId },
                        } ),
                    } ).catch( () => {} );
                }
            },
            joinWaitingRoom ()
            {
                this.$echo.private( `App.Frontend.WaitingRoom.${ this.id }` ).listen( 'FrontendWaitingRoomUpdated', ( streamData ) =>
                {
                  this.room.preview_image = streamData.preview_image;
                  if ( streamData.live !== this.room.live)
                  {
                    if(streamData.live) {
                      // The broadcast carries no stream_url, and it may have changed since the room was loaded
                      this.$apollo.query( {
                        query: gql`
                          query roomsEdit($id: ID!){
                              roomsEdit(id: $id) {
                                  id
                                  stream_url
                              }
                          }`,
                        variables: {
                          id: this.id,
                        },
                        fetchPolicy: "network-only"
                      } ).then( ( { data } ) =>
                      {
                        this.room.stream_url = data.roomsEdit.stream_url;
                      } ).finally( () =>
                      {
                        this.room.live = true;
                        this.joinRoom();
                      } );
                    } else {
                      this.room.live = false;
                      this.leaveRoom();
                    }
                  }
                } ).listen( 'FrontendChatUpdated', ( chat ) =>
                {
                  if ( chat )
                  {
                    this.room.chat = Object.assign( {}, chat );
                  }
                } );
            },
        },
        computed: {
            ...mapState( ['frame', 'room', 'roomLoading'] ),
            ...mapGetters( ['dark', 'loading'] ),
            displayableCertificateDownloadCountdown() {
              let totalSeconds = this.certificateDownloadCountdown / 1000;
              let hours = Math.floor(totalSeconds / (3600)).toString().padStart(2, '0');
              let minutes = (Math.floor(totalSeconds / 60) % 60).toString().padStart(2, '0');
              let seconds = (Math.floor(totalSeconds) % 60).toString().padStart(2, '0');

              return hours === '00' ? `${minutes}:${seconds}` : `${hours}:${minutes}:${seconds}`


            },
            notLiveText ()
            {
                if ( this.room.start && this.moment().isBefore( this.moment.tz( this.room.start, 'Europe/Berlin' ) ) )
                {
                    return this.$t( 'room.not_live.scheduled', {
                        hours: this.moment.tz( this.room.start,
                            'Europe/Berlin' ).fromNow(),
                    } );
                }
                if ( this.room.end && this.moment().isAfter( this.moment.tz( this.room.end, 'Europe/Berlin' ) ) )
                {
                    return this.$t( 'room.not_live.scheduled', {
                        hours: this.moment.tz( this.room.end,
                            'Europe/Berlin' ).fromNow(),
                    } );
                }
                return this.$t( 'room.not_live.default' );
            },
            dateRange ()
            {
                if ( this.room.start && this.room.end )
                {
                    let start = this.moment.tz( this.room.start, 'Europe/Berlin' );
                    let end = this.moment.tz( this.room.end, 'Europe/Berlin' );
                    if ( start.isSame( end, 'day' ) )
                    {
                        return this.moment.tz( this.room.start, 'Europe/Berlin' ).local().format( 'DD.MM.YYYY H:mm' ) + ' - ' + this.moment.tz( this.room.end, 'Europe/Berlin' ).local().format( 'H:mm' );
                    }
                    else {
                        return this.moment.tz( this.room.start, 'Europe/Berlin' ).local().format( 'DD.MM.YYYY H:mm' ) + ' - ' + this.moment.tz( this.room.end, 'Europe/Berlin' ).local().format( 'DD.MM.YYYY H:mm' );
                    }
                }
                if ( this.room.start )
                {
                    return this.moment.tz( this.room.start, 'Europe/Berlin' ).local().format( 'DD.MM.YYYY H:mm' );
                }
                return false
            },
        },
    };
</script>

<style scoped>
    >>> .v-list-item__title {
        text-overflow: unset;
        white-space: normal;
    }

    >>> .v-list-item__subtitle {
        text-overflow: unset;
        white-space: normal;
    }
</style>
